import VolatilityMessageSettings from "../components/VolatilityMessageSettings";


const VolatilityMessageSettingsPage = () => {
    return (
        <VolatilityMessageSettings />
    )
}

export default VolatilityMessageSettingsPage